import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

/* ============================================================
   SEDACAJ PRESET — PrimeNG styled theme
   Paleta base: Azul Institucional · Acento Dorado
   Alineada con los design tokens de styles-tokens.css
   ============================================================ */

const sedacajBlue = {
  50: '#F4F8FC',
  100: '#EAF2FB',
  200: '#D6E5F6',
  300: '#A8CBEA',
  400: '#82AFD9',
  500: '#5B9BD5',
  600: '#4C85BC',
  700: '#3D6FA3',
  800: '#315A88',
  900: '#24486E',
  950: '#1A3552',
};

const sedacajGold = {
  50: '#FDF6E8',
  100: '#FBE7C2',
  200: '#F6D899',
  300: '#EFC46F',
  400: '#ECB854',
  500: '#E8A93E',
  600: '#D19632',
  700: '#B5822C',
  800: '#94691F',
  900: '#745117',
  950: '#563A0F',
};

const surfaceLight = {
  0: '#FFFFFF',
  50: '#F6F9FB',
  100: '#EAF2FB',
  200: '#DCE2E8',
  300: '#D5DCE3',
  400: '#8A93A0',
  500: '#5A6470',
  600: '#46515E',
  700: '#1E2530',
  800: '#171D26',
  900: '#12161F',
  950: '#0D1119',
};

const surfaceDark = {
  0: '#F5F8FB',
  50: '#EAF0F6',
  100: '#D8E1EA',
  200: '#C2CDD9',
  300: '#A7B3C0',
  400: '#77879A',
  500: '#55647A',
  600: '#3A485C',
  700: '#2A3648',
  800: '#1A2535',
  900: '#141C26',
  950: '#0D141C',
};

const primary = {
  50: '{sedacaj.50}',
  100: '{sedacaj.100}',
  200: '{sedacaj.200}',
  300: '{sedacaj.300}',
  400: '{sedacaj.400}',
  500: '{sedacaj.500}',
  600: '{sedacaj.600}',
  700: '{sedacaj.700}',
  800: '{sedacaj.800}',
  900: '{sedacaj.900}',
  950: '{sedacaj.950}',
};

const accent = {
  50: '{sedacajgold.50}',
  100: '{sedacajgold.100}',
  200: '{sedacajgold.200}',
  300: '{sedacajgold.300}',
  400: '{sedacajgold.400}',
  500: '{sedacajgold.500}',
  600: '{sedacajgold.600}',
  700: '{sedacajgold.700}',
  800: '{sedacajgold.800}',
  900: '{sedacajgold.900}',
  950: '{sedacajgold.950}',
};

export const SedacajPreset = definePreset(Aura, {
  primitive: {
    sedacaj: sedacajBlue,
    sedacajgold: sedacajGold,
  },
  semantic: {
    primary,
    accent,
    colorScheme: {
      light: {
        surface: surfaceLight,
      },
      dark: {
        surface: surfaceDark,
      },
    },
  },
});
